<template>
  <div class="csy-container">
    <div :class="['nd-drag',{close: !open}, `caseId-${status}`]"  data-sensors-click ref="dragDom" @click="handleJump">
      <vue-lottie :options="lottieOptions" ></vue-lottie>
      <div class="close" @click.stop="open=false;;hideShow=true"></div>
      <div :class="['hide',{hideShow:hideShow}]" @click.stop="hideShow=false;;open=true"></div>
    </div>
    <div class="mask"></div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { getKey } from '../../assets/utils'
import VueLottie from 'vue-lottie'
import caishen from '@/assets/json/caishen.json'

export default {
  props: ['status'],
  data () {
    return {
      lottieOptions: {
        animationData: caishen, loop: true 
      },
      isDragged: false,
      domLeft: 0,
      domTop: 0,
      initX: 0,
      initY: 0,
      open: true,
      hideShow: false,
      topPosition: 0 // 页面顶部的限制距离
    }
  },
  components: {
    VueLottie
  },
  computed: {
    ...mapState({
      statusBarHeight: state => state.statusBarHeight || 0
    }),
    title () {
      const { title } = getKey('userInfo')
      return title
    }
  },
  mounted () {
    this.$sensors.track('Element_Exposure', { caseId: this.status })   
    setTimeout(() => {
      // 顶部距离修正，为确保顶部和底部的DOM加载完成，所以添加一个500ms的延迟
      this.topPosition += this.statusBarHeight
      const navDom = document.querySelector('.nd-navigation')
      if (navDom) {
        this.topPosition += navDom.offsetHeight
      }
      // TODO 这里减去了底部距离，应该还会减去app内部的header距离
      const tabbarDom = document.querySelector('.nd-tabbar')
      if (tabbarDom) {
        pageHeight -= tabbarDom.offsetHeight
      }
    }, 500)
    const dragDom = this.$refs.dragDom
    if (!dragDom) return
    // 页面宽度和高度
    const pageWidth = document.documentElement.clientWidth
    let pageHeight = document.documentElement.clientHeight
    // 拖拽元素宽度和高度
    const dragWidth = dragDom.offsetWidth
    const dragHeight = dragDom.offsetHeight

    // 初始化位置信息
    const dragPosition = JSON.parse(sessionStorage.getItem('dragPosition') || 'null')
    if (dragPosition) {
      dragDom.style.left = dragPosition.left
      dragDom.style.top = dragPosition.top
    } else {
      dragDom.style.left = pageWidth - dragWidth + 'px'
      dragDom.style.top = pageHeight - dragHeight - 120 + 'px'
    }

    dragDom.addEventListener('touchstart', (e) => {
      e.stopPropagation()
      this.isDragged = true
      this.initX = e.touches[0].clientX
      this.initY = e.touches[0].clientY
      this.domLeft = dragDom.offsetLeft
      this.domTop = dragDom.offsetTop
    })
    dragDom.addEventListener('touchmove', (e) => {
      e.preventDefault()
      e.stopPropagation()
      if (this.isDragged) {
        const x = e.touches[0].clientX
        const y = e.touches[0].clientY
        // 鼠标移动的距离
        const offsetX = x - this.initX
        const offsetY = y - this.initY
        // 鼠标移动后元素的新位置
        const newLeft = this.domLeft + offsetX
        const newTop = this.domTop + offsetY

        if (newLeft < 0) {
          dragDom.style.left = 0 + 'px'
        } else if (newLeft > pageWidth - dragWidth) {
          dragDom.style.left = pageWidth - dragWidth + 'px'
        } else {
          dragDom.style.left = newLeft + 'px'
        }
        if (newTop < this.topPosition) {
          dragDom.style.top = this.topPosition + 'px'
        } else if (newTop > pageHeight - dragHeight) {
          dragDom.style.top = pageHeight - dragHeight + 'px'
        } else {
          dragDom.style.top = newTop + 'px'
        }
      }
    })
    dragDom.addEventListener('touchend', () => {
      this.isDragged = false
      // 存储位置信息
      // const _left = dragDom.style.left.replace('px', '')
      // if (_left > (pageWidth - dragDom.clientWidth) / 2) {
      //   dragDom.style.left = `${pageWidth - dragDom.clientWidth}px`
      //   console.log(dragDom.style.left)
      // } else {
      //   dragDom.style.left = 0
      // }
      dragDom.style.left = `${pageWidth - dragDom.clientWidth}px`
      sessionStorage.setItem('dragPosition', JSON.stringify({
        left: dragDom.style.left,
        top: dragDom.style.top
      }))
    })
  },
  methods: {
    handleOpen () {
      this.open = true
      clearTimeout(window.timer)
      window.timer = setTimeout(() => {
        this.hideShow = true
      }, 300)
    },
    // 跳转页面
    handleJump () {
      // SHOW_GOD_OF_WEALTH_APPLY_SUCCESS 预授信通过未申请授信 
      // SHOW_GOD_OF_WEALTH_FUTURE_APPLY 未预授信展示财神爷
      
      // if (this.status === 'SHOW_GOD_OF_WEALTH_FUTURE_APPLY') {
      //   this.$router.push('/authentication/id')
      // } else {
      //   this.$router.push('/authentication/base')
      // }

      this.$router.push('/middle/limit')
    }
  }
}
</script>

<style lang="less" scoped>
@import "../../assets/less/mixin.less";

.nd-drag{
  width: 164px;
  height: 199px;
  position: fixed;
  top: 0;
  right: 0;
  z-index: 999;
  transition: transform 0.3s;
  padding-top: 40px;
  &.close {
    transform: translate(100%);
  }
   
  .hide {
    width:36px;
    height:72px;
    background: url(./images/btn_2.png) no-repeat center center;
    background-size: contain;
    position: absolute;
    top: 50%;
    margin-top: -36px;
    right: 164px;
    transform: translateX(200px);
    opacity: 0;
    transition: all 0.3s;
    &.hideShow {transform: translateX(0); opacity: 1;}
  }
  .close {
    position: absolute;
    width: 48px;
    height: 48px;
    background: url(./images/btn_1.png) no-repeat center center;
    background-size: 24px 24px;
    top:0; 
    right: 10px;
  }
  .drag-img{
    width: 100%;
  }
  .title {
    position: absolute;
    width:100%;
    left:0;
    bottom: 20px;
    text-align: center;
    line-height:30px;
      // text-stroke: 1px #C9752F;
      font-size: 19px;
      color: #FFFFFF;
      font-weight: bold;
      text-shadow: 0 0 2px #C9752F;
  }
}
</style>